export default __webpack_public_path__ + "static/media/has-on-site.d4738c02.svg";